@if (!shouldShowTableau) {
  <scitis-empty-state-fallback [fallBackMessage]="fallBackMessage">
  </scitis-empty-state-fallback>
}
@if (shouldShowTableau) {
  <div class="page-content page-content-full">
    <tableau-viz [src]="embeddedViewUrl"
      [style.display]="'flex'"
      [token]="viewJWTAccessToken"
      hide-tabs="true"
      hide-toolbar="false"
      id="tableauViz">
      @for (filter of tableauFilters; track filter) {
        <viz-parameter [attr.field]="filter.field" [attr.value]="filter.value"></viz-parameter>
      }
    </tableau-viz>
  </div>
}

